module.exports = __webpack_public_path__ + "media/images/riders/FLORIAN_VOGEL-374b32845bfe1fd5c237c09b519c0d10.png";